import { render, staticRenderFns } from "./note-toc.vue?vue&type=template&id=486ccce2"
import script from "./note-toc.vue?vue&type=script&lang=js"
export * from "./note-toc.vue?vue&type=script&lang=js"
import style0 from "./note-toc.vue?vue&type=style&index=0&id=486ccce2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports